function AdminCustomProfilePreviewPanel(props) {
  const mode = props.mode;
  const lang = props.lang;
  const channelType = props.channelType;

  if (mode === "default") {
    return (
      <div className="admin-custom-profile-preview-box">
        <div className="admin-custom-profile-preview-content">
          <img
            className="admin-custom-profile-preview-avatar"
            src={props.avatarUrl || ADMIN_CUSTOM_PROFILE_DEFAULT_IMAGE}
          />
          <div className="admin-custom-profile-preview-details">
            <div className="admin-custom-profile-preview-name-group">
              <div className="admin-custom-profile-preview-name">{props.displayname}</div>
              <div className="admin-custom-profile-preview-channel-note">
                from "{props.previewFrom}"
              </div>
            </div>
            <div className="admin-custom-profile-preview-bubble">
              {lang.__setting_admin_custom_profile_preview_message}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (mode === "disabled") {
    return (
      <div className="admin-custom-profile-preview-box">
        <div className="admin-custom-profile-preview-content">
          <img
            className="admin-custom-profile-preview-avatar"
            src="../public/img/LINE_SOCIAL_Basic.png"
          />
          <div className="admin-custom-profile-preview-details">
            <div className="admin-custom-profile-preview-name-group">
              <div className="admin-custom-profile-preview-name">"OA name"</div>
            </div>
            <div className="admin-custom-profile-preview-bubble">
              {lang.__setting_admin_custom_profile_preview_message}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (mode === "custom") {
    if (!props.hasConfiguredName) {
      return (
        <div className="admin-custom-profile-preview -empty">
          <div className="admin-custom-profile-preview-empty">
            {lang.__setting_admin_custom_profile_empty_preview}
          </div>
        </div>
      );
    }

    return (
      <div className="admin-custom-profile-preview-box">
        <div className="admin-custom-profile-preview-content">
          {props.previewImage ? (
            <img
              className="admin-custom-profile-preview-avatar"
              src={props.previewImage}
            />
          ) : props.hasConfiguredName && !props.hasConfiguredImage ? (
            <div
              className={
                "admin-custom-profile-preview-avatar admin-custom-profile-channel-icon -" +
                channelType
              }
            ></div>
          ) : (
            <div className="admin-custom-profile-preview-avatar"></div>
          )}
          <div className="admin-custom-profile-preview-details">
            {props.previewName ? (
              <div className="admin-custom-profile-preview-name-group">
                <div className="admin-custom-profile-preview-name">
                  {props.previewName}
                </div>
                <div className="admin-custom-profile-preview-channel-note">
                  from "{props.previewFrom}"
                </div>
              </div>
            ) : null}
            <div className="admin-custom-profile-preview-bubble">
              {lang.__setting_admin_custom_profile_preview_message}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
